import { FC } from 'react';

import { Partner } from 'types';
import { formatCurrencyDecimals, formatNumberDecimals } from 'utils/formats';
import { useDividendDocumentModal } from '../context/DividendDocumentModalContext';

type DividendDocumentTableRowProps = {
  index: number;
  partner: Partner;
};

const DividendDocumentTableRow: FC<DividendDocumentTableRowProps> = ({
  index,
  partner,
}) => {
  const { data, actions } = useDividendDocumentModal();

  const dividend = partner?.dividends?.find(
    (dividend) => dividend.operation === data.operationId
  );

  const ndPercentage = dividend?.ndPercentage || 0;
  const toPerceive =
    (dividend?.amount || 0) - (dividend?.retentionAmount || 0) || 0;

  const checkboxChecked = data.selectedPartners.some(
    (partnerItem) => partnerItem?._id === partner?._id
  );

  const handleChangeSelectedPartner = () => {
    actions.handleSelectPartner(partner);
  };

  return (
    <>
      <td>
        <div className="custom-control custom-control-xs custom-checkbox">
          <input
            type="checkbox"
            id={`checkbox-toggle-${index}-${partner?._id}`}
            className="custom-control-input"
            checked={checkboxChecked}
            onChange={handleChangeSelectedPartner}
          />
          <label
            className="custom-control-label "
            htmlFor={`checkbox-toggle-${index}-${partner?._id}`}
          >
            {partner?.name}
          </label>
        </div>
      </td>

      <td className="tb-tnx-amount">
        <span className="amount">{formatNumberDecimals(ndPercentage)}%</span>
      </td>

      <td className="tb-tnx-amount">
        <span>{formatCurrencyDecimals(toPerceive)}</span>
      </td>
    </>
  );
};

export default DividendDocumentTableRow;
